import InfoButton from "../InfoButton/InfoButton";

export default function TopSearchItem(props) {
    return (
        <div className="flex justify-between py-4">
            <p>{props.title}</p>
            <InfoButton info={props.info} />
        </div>
    )
}
